import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import './carto-de-visita.css'

const CartoDeVisita = (props) => {
  return (
    <div className="carto-de-visita-container1">
      <Helmet>
        <title>Carto-de-visita - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Carto-de-visita - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <Link to="/" className="carto-de-visita-navlink1">
        <img
          alt="logo"
          src="/logo.svg"
          loading="eager"
          className="carto-de-visita-image"
        />
      </Link>
      <div className="carto-de-visita-container2">
        <Link to="/" className="carto-de-visita-navlink2 button">
          Website
        </Link>
        <a
          href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=65992993749"
          target="_blank"
          rel="noreferrer noopener"
          className="carto-de-visita-link1 button"
        >
          Whatsapp
        </a>
        <a
          href="https://www.instagram.com/wandersoncavalari.adv1/"
          target="_blank"
          rel="noreferrer noopener"
          className="carto-de-visita-link2 button"
        >
          Instagram
        </a>
      </div>
    </div>
  )
}

export default CartoDeVisita
